// src/graphQlQueries/queries/getPublicationLogsByGroupId.js
import gql from 'graphql-tag';

export default gql`
  query getPublicationLogsByGroupId($groupId: Int!) {
    publication_logs(
      where: { group_id: { _eq: $groupId } }
      order_by: { published_at: desc }
      limit: 200
    ) {
      published_at
      page_id
      page_version_id
      user_id
      project_id
      user {
        full_name
        email
      }
      page {
        name
      }
      project {
        name
      }
    }
  }
`;
